<template lang="pug">
#page_content.faq.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.article
		.row.justify-content-center: .col-sm-10
			template(v-if='$i18n.locale === "tw"')
				.item_question
					.question Q: 線上影展什麼時候開始播映？
					.answer A: 本屆的線上影展展期為3/14（一）－4/18（一）請鎖定公視＋兒童影展頻道！因各影片廠商授權開放不同，分別限時觀看五週或兩年，趕緊將播映時間加入行事曆，不要錯過唷！
				.item_question
					.question Q: 怎麼觀看線上影展？
					.answer A: 註冊公視＋即可觀看囉！如何註冊請看公視+線上註冊教學
				.item_question
					.question Q: 線上影展需要付費嗎？
					.answer A: 註冊公視+後，即可免費觀賞兒童影展的所有影片！
				.item_question
					.question Q: 我未滿18歲可以註冊公視＋嗎？
					.answer A: 註冊公視＋會員須滿18歲，請大人協助註冊後，再一起欣賞線上影展的影片
				.item_question
					.question Q: 公視＋不能正常觀看怎麼辦？
					.answer A: 公視+相關疑問請至公視＋問答，如仍無法順利觀看，請撥打客服專線(02)2633-2000#9
				.item_question
					.question Q: 線上影展的影片可以在任何地方收看嗎？
					.answer A: 線上影展僅授權於台灣以公視+個人帳號登入後收看，不得於公開場合進行公開播放唷！
			template(v-else)
				.item_question
					.question Q: When will the 10th TICFF take place?
					.answer A: The 10th TICFF will begin on March 14th to April 18th on PTS+ channel. Please kindly note that the licensing period of each new-listed film might differ from one another (limited 5 weeks or 2 years), it is advised that you check the screening info in advance and add your preferable ones to your calendar before you miss out the schedule!
				.item_question
					.question Q: How to watch films from TICFF online?
					.answer 
						| A: Please sign up an account on PTS+ first, then you can watch all the films for free!
						|
						b The PTS+ online registration guideline
						|
						| will help you create an account and sign in. Registration is free as well.
				.item_question
					.question Q: Any fee required for watching online films from TICFF?
					.answer A: You will be charged with nothing. Just remember to sign in with your PTS+ account and you can watch all films from TICFF for free.
				.item_question
					.question Q: I am under 18, can I sign up an account on PTS+?
					.answer A: We have an age requirements on PTS+ account. For users under 18, please ask your parents/legal representative to create an PTS+ account before enjoying the films.
				.item_question
					.question Q: I cannot watch the videos on PTS+, what should I do?
					.answer
						| A: Please refer to our FAQ on PTS+ website first
						|
						a.link(href='https://www.ptsplus.tv/media-question', target='_blank') https://www.ptsplus.tv/media-question
						| ,
						|
						a.link(href='https://www.ptsplus.tv/other-question', target='_blank') https://www.ptsplus.tv/other-question
						| . If it does not solve the issue, please contact our customer service hotline: +886 26332000#9
				.item_question
					.question Q: Can I watch the films of TICFF from other countries?
					.answer A: No, all the videos are only available in Taiwan, and you have to sign in the PTS+ account before watching. Please also know that all the films are licensed for HOME USE ONLY, any public broadcasting is not allowed! Violation against the licensing agreement might be subject to legal prosecution.
</template>

<script>
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/banner_3.jpg',
				title: '常見問答',
			},
		};
	},
	components: {
		Banner,
	},
};
</script>

<style lang="stylus">
#page_content.faq
	.article
		padding: 6rem 0
	.item_question
		margin-bottom: 3rem
		.question, .answer
			font-size: $fs-3
			color: white
			line-height: 1.5
		.question
			margin-bottom: 0.25rem
		a.link
			color: $color_yellow
</style>
